/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ResetPasswordTokenRequest
 */
export interface ResetPasswordTokenRequest {
  /**
   * 6-значный код из письма
   * @type {string}
   * @memberof ResetPasswordTokenRequest
   */
  code: string
}

/**
 * Check if a given object implements the ResetPasswordTokenRequest interface.
 */
export function instanceOfResetPasswordTokenRequest(
  value: object
): value is ResetPasswordTokenRequest {
  if (!('code' in value) || value['code'] === undefined) return false
  return true
}

export function ResetPasswordTokenRequestFromJSON(
  json: any
): ResetPasswordTokenRequest {
  return ResetPasswordTokenRequestFromJSONTyped(json, false)
}

export function ResetPasswordTokenRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResetPasswordTokenRequest {
  if (json == null) {
    return json
  }
  return {
    code: json['code'],
  }
}

export function ResetPasswordTokenRequestToJSON(
  value?: ResetPasswordTokenRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    code: value['code'],
  }
}
